import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import { Auth, Event } from '../../support';
import Storage from '../../support/Storage';
import SwitchEmpresasList from './list/SwitchEmpresasList';

class SwitchEmpresas extends Component {
  componentDidMount() {
    window.setAppTitle('Empresas');
  }

  handleOnRowClick = async (empresa) => {
    const { empresa: preconfigurado } = Auth.getData();

    const data = {
      ...Auth.getData(),
      empresa: {
        ...empresa,
        live: preconfigurado.live || false,
      },
    };

    await window.resetApp();

    Storage.put('facturotopia', data);

    Auth.setData(data);

    const { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };

    this.props.history.replace(from);

    Event.dispatch('app.refresh');
  };

  render() {
    return (
      <div>
        <Row className="mb-3">
          <Col className="text-right">
            <h5 className="pt-2">Empresas</h5>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>Selecciona de la lista para cambiar de empresa</Col>
        </Row>

        <SwitchEmpresasList
          onRowClick={this.handleOnRowClick}
          // onRowSelectionChange={this.handleOnRowSelectionChange}
        />
      </div>
    );
  }
}

export default SwitchEmpresas;
